import './style.scss';

export function treatments_speciality_block() {
  const blocks = document.querySelectorAll('.treatments_speciality_block');
  if (!blocks.length) return;
  blocks.forEach(block => {

  const Cards = block.querySelectorAll(".card-wrapper");
  const Buttons = block.querySelectorAll(".service-button");
  Buttons.forEach((btn, index) => {
    btn.addEventListener('click', () => {

      Buttons.forEach(b => b.classList.remove("active-link"));
      btn.classList.add("active-link");

      Cards.forEach(card => card.classList.remove("active-post"));
      // Add active-post to the card with same index
      Cards[index].classList.add("active-post");
    });
  });
  });

}
